import { useState } from "react";
import { ChevronDown, ChevronRight, EyeOff } from "lucide-react";
import { ChoiceButton } from "@/components/ChoiceButton";

// NOT NEEDED, FOLDED (his call, 4 Nov): the tags marked not needed stay on the read under one "Not needed" line —
// closed by default, each with who marked it and when, and Undo right there for anyone who can edit the part.
export function AiTagsNotNeededFold({ items, canEdit, onUndo }) {
  const [open, setOpen] = useState(false);
  if (!items.length) return null;
  return (
    <div data-testid="ai-tags-not-needed" className="rounded-xl border border-dashed border-slate-300 bg-slate-50">
      <button type="button" data-testid="ai-tags-not-needed-toggle" onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-3 py-2 text-left text-xs text-slate-600 min-h-[44px]">
        {open ? <ChevronDown className="w-3.5 h-3.5 text-slate-400" /> : <ChevronRight className="w-3.5 h-3.5 text-slate-400" />}
        <EyeOff className="w-3.5 h-3.5 text-slate-400" />
        <b className="uppercase tracking-widest text-[11px] whitespace-nowrap">Not needed</b>
        <span data-testid="ai-tags-not-needed-count" className="whitespace-nowrap">{items.length} tag{items.length === 1 ? "" : "s"}</span>
        <span className="hidden sm:inline text-slate-400">— nothing deleted; open to see them or bring one back</span>
      </button>
      {open && (
        <div className="border-t border-dashed border-slate-300 p-2 space-y-1.5">
          {items.map(({ gi, name, values, by, at }) => (
            <div key={gi} data-testid={`ai-tag-group-hidden-${gi}`} className="flex flex-wrap items-center gap-2 rounded-lg bg-white border border-slate-200 px-3 py-2 text-xs text-slate-500">
              <div className="min-w-0 flex-1">
                <b className="uppercase tracking-widest text-[11px] text-slate-600">{name}</b>
                <span className="ml-2">{values.length} number{values.length === 1 ? "" : "s"}</span>
                <div className="font-mono text-[11px] text-slate-400 truncate">{values.join("  ·  ")}</div>
                <div data-testid={`ai-tag-group-hidden-who-${gi}`} className="text-[11px] text-slate-500">
                  Marked not needed{by ? ` by ${by.split("@")[0]}` : ""}{at ? ` · ${new Date(at).toLocaleDateString("en-CA")}` : ""}
                </div>
              </div>
              {canEdit && (
                <ChoiceButton data-testid={`ai-tag-group-needed-again-${gi}`} onClick={() => onUndo(gi)} className="h-9 min-h-9 ml-auto">
                  Undo — show it again
                </ChoiceButton>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
